import './OrderPrintsModal.css';
import * as React from 'react';
import { IModalProps } from '../../Modal';
import ShippingInfoInteractiveModal from './Components/ShippingInfoInteractiveModal';
import { IDocument, IOrderQuantities_Addresses, IUserData } from '../../../infrastructure/interfaces';

export interface IOrderPrintsProps extends IModalProps {
  state: any;
  document: IDocument | null;
  comments: string;
  orderQuantityAddressPairs: IOrderQuantities_Addresses[];
  selectedOrderQuantityAddressPair: IOrderQuantities_Addresses;
  orderQuantityAddressPairIndex: number;
  userData:IUserData;
  onPlaceOrder(document: any, userID: string): void;
  onSaveOrderQuantityAddressPair(orderQuantityAddressPair: IOrderQuantities_Addresses): void;
  onStartNewOrderQuantityAddressPair(): void;
  onSelectedEditOrderQuantityAddressPair(itemIndex: number): void;
  onSelectedDeleteOrderQuantityAddressPair(itemIndex: number): void;
  onFieldChange(e: any): void;
  onDocumentNameFieldChange(e: any): void;
  onOrderCommentsFieldChange(e: any): void;
}
const OrderPrintsModal = ({
  show,
  document,
  comments,
  orderQuantityAddressPairs,
  selectedOrderQuantityAddressPair,
  orderQuantityAddressPairIndex,
  userData,
  onClose,
  state,
  onFieldChange,
  onPlaceOrder,
  onSaveOrderQuantityAddressPair,
  onStartNewOrderQuantityAddressPair,
  onSelectedEditOrderQuantityAddressPair,
  onSelectedDeleteOrderQuantityAddressPair,
  onDocumentNameFieldChange,
  onOrderCommentsFieldChange
}: IOrderPrintsProps) => {
  return <ShippingInfoInteractiveModal
      document={document}
      comments={comments}
      orderQuantityAddressPairs={orderQuantityAddressPairs}
      selectedOrderQuantityAddressPair={selectedOrderQuantityAddressPair}
      orderQuantityAddressPairIndex={orderQuantityAddressPairIndex}
      userData={userData}
      show={show}
      onClose={onClose}
      state={state}
      onFieldChange={onFieldChange}
      onPlaceOrder={onPlaceOrder}
      onSaveOrderQuantityAddressPair={onSaveOrderQuantityAddressPair}
      onStartNewOrderQuantityAddressPair={onStartNewOrderQuantityAddressPair}
      onSelectedEditOrderQuantityAddressPair={onSelectedEditOrderQuantityAddressPair}
      onSelectedDeleteOrderQuantityAddressPair={onSelectedDeleteOrderQuantityAddressPair}
      onDocumentNameFieldChange={onDocumentNameFieldChange}
      onOrderCommentsFieldChange={onOrderCommentsFieldChange}
    />;
};

export default OrderPrintsModal;



// WEBPACK FOOTER //
// ./src/components/Modals/OrderPrintsModal/OrderPrintsModal.tsx